import { useContext, useEffect, useState } from 'react';
import LoadingIcon from "../../components/LoadingIcon/LoadingIcon";
import { SearchResultItemDt } from '../../Models/SearchModel';
import { myAds } from '../../Api/Services/Search';
import styles from "../SearchPage/searchPage.module.css";
import SearchResult from "../SearchPage/SearchResult/SearchResult";
import { AccountContext } from '../../Store/Account.store';

export default function MyAds() {

  const [items, setItems] = useState<SearchResultItemDt[]>([]);
  const [loading, setLoading] = useState(true);
  const {accountData} = useContext(AccountContext);

 
  useEffect(() => {
    setLoading(true);
    myAds().then((requestData) => {
      setItems(requestData);
      setLoading(false);
    });
  }, []);

  return (
    <div className={`${styles.search_container} container`}>
      <h1>My ads</h1>
      <p>{accountData.username}</p>
      {loading && <LoadingIcon />}
        <div className={styles.search_result_container}>
          {loading && <LoadingIcon />}
          {items.map((item, index) => (
            <SearchResult key={index} item={item} quality={item.alternativeLevel} />
          ))}
        </div>
    </div>
  );
}
